export interface IAuthState {
  isAuthenticated: boolean;
  appConfigLoaded: boolean;
  appConfigSettings: AppConfigSettings;
  user: UserInfo;
}

export class AppConfigSettings {
  adminUrl = '';
  authorityUrl = '';
}

export class UserInfo {
  constructor(
    public userName: string = '',
    public userId: number = 0,
    public userAuthId: string = '',
    public firstName: string = '',
    public lastName: string = ''
  ) {}
}

export class AuthState implements IAuthState {
  isAuthenticated: boolean = false;
  appConfigLoaded: boolean = false;
  appConfigSettings: AppConfigSettings = new AppConfigSettings();
  user: UserInfo = new UserInfo('unknown user');
}
